import * as navigation from 'Navigation';

export default class MoleculeChemicalStructureTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Chemical Structure',
      closeable: false,
      preferenceKey: 'molecule-chemical-structure',
    };
  }
}
